$ = require 'jquery'
Confirm = require 'app/scripts/views/lib/confirm'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class CustomBackgroundOptionsView extends View
  viewTitleKey: 'background options'

  initialize: ->
    @listenTo @model, 'change', @render

  events:
    'click .js-delete-background': 'deleteBackground'
    'click .js-select-option': 'selectOption'

  render: ->
    data = @model.toJSON()

    data.tile = @model.get('tile')
    brightness = @model.get('brightness')
    data.brightnessLight = (brightness == 'light')
    data.brightnessDark = (brightness == 'dark')

    @$el.html(
      templates.fill(
        require('app/scripts/views/templates/board_background_options'),
        data
      )
    )

    @

  selectOption: (e) ->
    $option = $(e.target).closest('.js-select-option')

    if $option.attr('data-board-brightness')?
      @model.update('brightness', $option.attr('data-board-brightness'))
    else if $option.attr('data-background-display-type')?
      selection = $option.attr('data-background-display-type')
      @model.update('tile', selection == 'tile')
    return

  deleteBackground: (e) ->
    Util.stop(e)
    Confirm.pushView 'delete background',
      elem: $(e.target).closest('.js-delete-background')
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.destroy()
        @remove()
        track("Board Menu", "Change Background", "Delete Uploaded Background")
        if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
          Analytics.sendTrackEvent
            action: 'deleted'
            actionSubject: 'boardBackground'
            actionSubjectId: 'customBoardBackground'
            source: 'boardMenuDrawerBackgroundScreen'
            containers:
              board:
                id: @model.id
